export const DEFAULT_FONT_SIZES = {
  h1: 3.5,
  h2: 2,
  h3: 1.3,
  h4: 1.2,
  h5: 1,
  h6: 0.875,
  p: 0.875,
  small: 0.75,
  xsmall: 0.625,
  xxsmall: 0.55,
  xxxsmall: 0.45
}
